import 'react-table/react-table.css';
import React from 'react';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';

import InboundOrderHelpers from '../../../helpers/inboundOrders';
import FormatHelpers from '../../../helpers/format';

export default class ProductsList extends React.Component {
  render() {
    const { products } = this.props;
    return (
      <div className="table table-bordered">
        <table className="table widget-table widget-table-rounded">
          <thead>
            <tr className="text-center f-s-14">
              <th width="5%">{I18n.t('BEE463' /* Linha */)}</th>
              <th width="35%">{I18n.t('BEE225' /* Produto */)}</th>
              <th width="10%">{I18n.t('BEE441' /* Quantidade */)}</th>
              <th width="10%">{I18n.t('BEE384' /* Unidade */)}</th>
              <th width="10%">{I18n.t('BEE1057' /* Entrega */)}</th>
              <th width="15%">{I18n.t('BEE3789' /* Ordem de Compra */)}</th>
              <th width="30%">{I18n.t('BEE135' /* Observação */)}</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => (
              <tr className="text-center" key={product.lineNumber}>
                <td>
                  <h5>{product.lineNumber}</h5>
                </td>
                <td className="text-left">
                  <h4 className="widget-table-title">{product.productCode}</h4>
                  <p className="widget-table-desc m-b-15">{product.product.name}</p>
                  <p className="widget-table-desc m-b-15">{product.product.fullName}</p>
                  <div className="clearfix f-s-10">
                    {`${I18n.t('BEE224' /* Status */)}:`}
                    <b className="text-inverse">{InboundOrderHelpers.inboundOrderProductStatus(product.status)}</b>
                  </div>
                </td>
                <td>
                  {FormatHelpers.formatNumber(product.quantity, 4)}
                </td>
                <td>
                  {product.unitMeasure}
                </td>
                <td>
                  {moment(product.deliveryDate).format('DD/MM/YYYY')}
                </td>
                <td>
                  {product.purchaseOrder}
                </td>
                <td>
                  {product.note}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
